// extracted by mini-css-extract-plugin
module.exports = {"more":"index-module--more--TMQ_C","blog":"index-module--blog--1OOz-","link":"index-module--link--3a3Th","blogmore":"index-module--blogmore--2q0gI"};